import React from "react";
import { Link } from "react-router-dom";

import logo from "../../../assets/images/helloSuperStar.png";
import TopInfo from "../../../Layouts/TopInfo";

const Navbar = () => {
  const sidebarToggle = () => {
    document.body.classList.toggle("sb-sidenav-toggled");
    localStorage.setItem(
      "sb|sidebar-toggle",
      document.body.classList.contains("sb-sidenav-toggled")
    );
  };

  return (
    <nav className="sb-topnav navbar navbar-expand navbar-dark bg-dark">
      <div className="d-flex justify-content-between align-items-center desk-tab-x ">
        <div>
          <Link className="Link" to="/audition-admin/dashboard">
            <img
              src={logo}
              alt=""
              className="logo-ad-logo px-2"
              style={{ width: "40px" }}
            />
            <span className="navbar-brand LogoName">Audition Admin</span>
          </Link>
        </div>
        <div>
          <button
            className="btn btn-link btn-sm order-1 order-lg-0 me-4 me-lg-0 text-white"
            id=""
            onClick={sidebarToggle}
          >
            <i className="fas fa-bars"></i>
          </button>
        </div>
      </div>

      <form className="d-md-inline-block form-inline ms-auto me-0 me-md-3 my-2 my-md-0">
        <div className="input-group">
          <input
            className="form-control SearchS "
            type="search"
            placeholder="Search for..."
            aria-label="Search for..."
            aria-describedby="btnNavbarSearch"
          />
          <button
            className="btn btn-warning btnS "
            id="btnNavbarSearch"
            type="button"
          >
            <i className="fas fa-search"></i>
          </button>
        </div>
      </form>

      <ul className="navbar-nav ms-auto ms-md-0 me-3 me-lg-4">
        <TopInfo
          profile={"/audition-admin/profile"}
          settings={"/audition-admin/profile-settings"}
        />
      </ul>
    </nav>
  );
};

export default Navbar;
